<template>
  <div>

  </div>
</template>

<script>
  export default {
    name: 'OauthRedirect'
  }
</script>
